package com.devi3east.bashbuddy.prizeList.domain.models

import com.devi3east.bashbuddy.account.profile.domain.models.Profile
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class Prize(
    val _id: String,
    val eventId: String,
    val eventHostId: String,
    val ticketId: String? = null,
    val prizeType: PrizeType,
    val title: String? = null,
    val timeSlotInstant: Instant? = null,
    val serialNumber: String? = null,
    val winningNumber: String? = null,
    val winnerProfile: Profile? = null
)